(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-announcement-bar"] && !Shopify.designMode) return;
  try {
    
function aaAnnouncementBarInit() {
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  document.querySelectorAll('[data-aa-ab]').forEach(function (bar) {
    if (bar.dataset.aaInit) return;
    bar.dataset.aaInit = 'true';

    // Close button: remembered for the browser session (ignored in the theme editor so it stays editable).
    var key = bar.dataset.dismissKey;
    if (key && !designMode) {
      try {
        if (sessionStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
    }
    var closeBtn = bar.querySelector('[data-aa-ab-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        if (key && !designMode) {
          try { sessionStorage.setItem(key, '1'); } catch (e) {}
        }
      });
    }

    // Countdown: every copy (static + ticker clone) is updated together.
    var timers = bar.querySelectorAll('[data-aa-ab-countdown]');
    var end = new Date(bar.dataset.end).getTime();
    if (isNaN(end)) return;
    var hideBar = bar.dataset.hideOnExpire === 'true';
    var interval;

    function pad(n) {
      return String(n).padStart(2, '0');
    }
    function set(sel, value) {
      bar.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
    }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (hideBar && !designMode) bar.hidden = true;
        bar.querySelectorAll('[data-aa-ab-countdown], [data-aa-ab-countdown-sep]').forEach(function (t) { t.hidden = true; });
        if (interval) clearInterval(interval);
        return;
      }
      if (!timers.length) return;
      set('[data-d]', pad(Math.floor(diff / 86400000)));
      set('[data-h]', pad(Math.floor((diff % 86400000) / 3600000)));
      set('[data-m]', pad(Math.floor((diff % 3600000) / 60000)));
      set('[data-s]', pad(Math.floor((diff % 60000) / 1000)));
    }

    tick();
    interval = setInterval(tick, 1000);
  });
}

aaAnnouncementBarInit();
document.addEventListener('shopify:section:load', aaAnnouncementBarInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-winter-announcement-bar"] && !Shopify.designMode) return;
  try {
    
function aaWinterBarInit() {
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  document.querySelectorAll('[data-aa-wbar]').forEach(function (bar) {
    if (bar.dataset.aaInit) return;
    bar.dataset.aaInit = 'true';

    // Close button: remembered for the browser session (ignored in the theme editor so it stays editable).
    var key = bar.dataset.dismissKey;
    if (key && !designMode) {
      try {
        if (sessionStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
    }
    var closeBtn = bar.querySelector('[data-aa-wbar-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        if (key && !designMode) {
          try { sessionStorage.setItem(key, '1'); } catch (e) {}
        }
      });
    }

    // Countdown: every copy (static + ticker clone) is updated together.
    var timers = bar.querySelectorAll('[data-aa-wbar-countdown]');
    var end = new Date(bar.dataset.end).getTime();
    if (isNaN(end)) return;
    var hideBar = bar.dataset.hideOnExpire === 'true';
    var interval;

    function pad(n) {
      return String(n).padStart(2, '0');
    }
    function set(sel, value) {
      bar.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
    }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (hideBar && !designMode) bar.hidden = true;
        bar.querySelectorAll('[data-aa-wbar-countdown], [data-aa-wbar-countdown-sep]').forEach(function (t) { t.hidden = true; });
        if (interval) clearInterval(interval);
        return;
      }
      if (!timers.length) return;
      set('[data-d]', pad(Math.floor(diff / 86400000)));
      set('[data-h]', pad(Math.floor((diff % 86400000) / 3600000)));
      set('[data-m]', pad(Math.floor((diff % 3600000) / 60000)));
      set('[data-s]', pad(Math.floor((diff % 60000) / 1000)));
    }

    tick();
    interval = setInterval(tick, 1000);
  });
}

aaWinterBarInit();
document.addEventListener('shopify:section:load', aaWinterBarInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-winter-sale-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initCountdown(el) {
    if (el.dataset.aaInit) return;
    el.dataset.aaInit = 'true';

    var end = new Date(el.dataset.end).getTime();
    if (isNaN(end)) return;

    var hero = el.closest('[data-aa-winter-hero]');
    var wrap = el.closest('[data-countdown-wrap]');
    var expiredEl = wrap ? wrap.querySelector('[data-expired-message]') : null;
    var hideSection = el.dataset.afterEnd === 'hide' && !(window.Shopify && window.Shopify.designMode);
    var parts = {
      d: el.querySelector('[data-days]'),
      h: el.querySelector('[data-hours]'),
      m: el.querySelector('[data-minutes]'),
      s: el.querySelector('[data-seconds]')
    };

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        el.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        if (hero) {
          hero.classList.add('is-expired');
          if (hideSection) hero.hidden = true;
        }
        clearInterval(el._aaTimer);
        return;
      }
      parts.d.textContent = pad(Math.floor(diff / 86400000));
      parts.h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      parts.m.textContent = pad(Math.floor((diff % 3600000) / 60000));
      parts.s.textContent = pad(Math.floor((diff % 60000) / 1000));
    }

    tick();
    el._aaTimer = setInterval(tick, 1000);
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    // Fallback for browsers without the async clipboard API.
    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      area.remove();
      ok ? resolve() : reject();
    });
  }

  function initCopy(btn) {
    if (btn.dataset.aaInit) return;
    btn.dataset.aaInit = 'true';
    btn.addEventListener('click', function () {
      var text = btn.dataset.aaWinterCopy;
      if (!text) return;
      copyText(text).then(function () {
        var original = btn.textContent;
        btn.textContent = btn.dataset.copiedLabel || 'Copied!';
        setTimeout(function () { btn.textContent = original; }, 2000);
      }).catch(function () {});
    });
  }

  // Desktop keeps the highlight on one line; if a long translation doesn't fit, scale it down.
  function fitHighlights() {
    var desktop = window.matchMedia('(min-width: 750px)').matches;
    document.querySelectorAll('[data-aa-winter-highlight]').forEach(function (el) {
      el.style.fontSize = '';
      if (!desktop) return;
      var available = el.parentElement.clientWidth - 8;
      var needed = el.scrollWidth;
      if (needed > available && available > 0) {
        var size = parseFloat(getComputedStyle(el).fontSize);
        el.style.fontSize = Math.floor(size * available / needed) + 'px';
      }
    });
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-aa-winter-countdown]').forEach(initCountdown);
    root.querySelectorAll('[data-aa-winter-copy]').forEach(initCopy);
    fitHighlights();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitHighlights, 150);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHighlights);

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  // Stop timers for sections removed or re-rendered in the theme editor.
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-aa-winter-countdown]').forEach(function (el) {
      clearInterval(el._aaTimer);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
